/**
 * Axios Client with defaults parameters
 */
import axios from 'axios';
import * as Oidc from 'oidc-client';
import { resolve } from 'path';
const tokenKey = "ChangeLoggerAccessToken";

const axiosInstanse = axios.create({
  baseURL: process.env.BACKEND_URL
  // timeout: 1000,
});

const mgr =
  new Oidc.UserManager({
    userStore: new Oidc.WebStorageStateStore({ store: window.localStorage }),
    authority: process.env.PASSPORT_URI,
    client_id: "change.logger",
    redirect_uri: process.env.AUTH_REDIRECT_URI,
    response_type: "id_token token",
    scope: "openid profile email change.logger.roles fr.id.role fr.cloud.role",
    post_logout_redirect_uri: process.env.POST_LOGOUT_URI,
    loadUserInfo: true,
    //accessTokenExpiringNotificationTime: 3540,
    includeIdTokenInSilentRenew: true,
    // silent renew will get a new access_token via an iframe 
    // just prior to the old access_token expiring (60 seconds prior)
    silent_redirect_uri: process.env.SILENT_REDIRECT_URI, //window.location.protocol + "//" + window.location.host + "/silent",
    automaticSilentRenew: true,

    // will revoke (reference) access tokens at logout time
    revokeAccessTokenOnSignout: true,

    // this will allow all the OIDC protocol claims to be visible in the window. normally a client app 
    // wouldn't care about them or want them taking up space
    filterProtocolClaims: false
  });

mgr.events.addAccessTokenExpiring(function () {
  console.log("Access token expiring...");
});

mgr.events.addSilentRenewError(function (err) {
  console.log("Silent renew error: " + err.message);
});

const setHeaderInternal = () => {
  return new Promise((resolve, reject) => {

    mgr.getUser().then(function (user) {
      if (user) {
        if (user.expired) {

          mgr.signinSilent().then(() => {
            axiosInstanse.defaults.headers.common['Authorization'] = 'Bearer ' + user.access_token;
            resolve();
          }).catch(ex => {
            mgr.signinRedirect();
          })
        }
        else {
          axiosInstanse.defaults.headers.common['Authorization'] = 'Bearer ' + user.access_token;
          resolve();
        }

      }
    })
      .catch(e => {
        reject();
        console.log(e);
      });

  });

}

const deleteHeader = () => {
  axiosInstanse.defaults.headers.common['Authorization'] = null;
}

const MagicHttp = {
  get: (...args) => {
    return new Promise((resolve, reject) => {

      MagicHttp.setHeader().then(() => {

        resolve(axiosInstanse.get(...args));
      })

    });

  },
  post: (...args) => {

    return new Promise((resolve, reject) => {

      MagicHttp.setHeader().then(() => {

        resolve(axiosInstanse.post(...args));
      })

    });

  },
  put: (...args) => {
    return new Promise((resolve, reject) => {

      MagicHttp.setHeader().then(() => {

        resolve(axiosInstanse.put(...args));
      })

    });
  },
  delete: (...args) => {
    return new Promise((resolve, reject) => {

      MagicHttp.setHeader().then(() => {

        resolve(axiosInstanse.delete(...args));
      })

    });
  },
  load: () => {

    return MagicHttp.setHeader();

  },
  logout: () => {
    mgr.signoutRedirect();
    deleteHeader();
  },
  setHeader: () => setHeaderInternal(),

  signinRedirect: (...args) => (mgr.signinRedirect(...args)),
  signinRedirectCallback: (...args) => (mgr.signinRedirectCallback(...args)),
  getUser: (...args) => (mgr.getUser(...args)),
  removeUser: (...args) => (mgr.removeUser(...args)),
  signinSilentCallback: (...args) => (mgr.signinSilentCallback(...args)),
  getUser: () => (mgr.getUser()),
  setUserProfile: (userProfile) => {
    localStorage.setItem("userProfile", JSON.stringify(userProfile));
  },
  getUserProfile: () => (JSON.parse(localStorage.getItem("userProfile"))),
  deleteUserProfile: () => {
    localStorage.removeItem("userProfile");
  }

}

export default MagicHttp;



// WEBPACK FOOTER //
// ./src/components/Http.js